<template>
  <div class="content">
    <div class="row">
      <div class="col">
        <div class="block" v-for="category in categories" :key="category.id">
          <div class="block-header block-header-default">
            <h3 class="block-title">{{ category.name }}</h3>
          </div>
          <div class="block-content">
            <bs-table
              presetColumn="price"
              :columns="[
                {
                  name: 'Naam',
                  key: 'name',
                  class: 'font-w700',
                  sort: true,
                },
                {
                  name: 'Aantal',
                  key: 'sites_count',
                  sort: true,
                  tooltip: 'Dit betreft het aantal startpagina\'s in het desbetreffende linkpakket.',
                },
                {
                  name: 'IP',
                  key: 'total_ip',
                  sort: true,
                  tooltip: ' Dit betreft het totaal aantal verschillende IP backlinks naar alle startpaginalinks in het desbetreffende linkpakket.',
                },
                {
                  name: 'PA',
                  key: 'average_pa',
                  sort: true,
                  tooltip: 'Dit betreft de gemiddelde PA waarde van alle startpaginalinks in het desbetreffende linkpakket.',
                },
                {
                  name: 'DA',
                  key: 'average_da',
                  sort: true,
                  tooltip: 'Dit betreft de gemiddelde DA waarde van alle startpaginalinks in het desbetreffende linkpakket.',
                },
                {
                  name: 'TF',
                  key: 'average_tf',
                  sort: true,
                  tooltip: 'Dit betreft de gemiddelde TF waarde van alle startpaginalinks in het desbetreffende linkpakket.',
                },
                {
                  name: 'CF',
                  key: 'average_cf',
                  sort: true,
                  tooltip: 'Dit betreft de gemiddelde CF waarde van alle startpaginalinks in het desbetreffende linkpakket.',
                },
                {
                  name: 'Totaal',
                  key: 'sites_price',
                  sort: true,
                  tooltip: 'Indien u gebruikerskorting heeft, wordt deze in de winkelwagen berekend',
                },
                {
                  name: 'Pakketprijs',
                  key: 'price',
                  sort: true,
                },
                {
                  name: 'Acties',
                  key: 'id',
                  class: 'text-center',
                },
              ]"
              :data="category.packages"
            >
              <template v-slot:Naam="{ props }">
                <a :href="$route('packages.show', props.id)" class="link-fx">{{ props.name }}</a>
              </template>
              <template v-slot:Aantal="{ props }">
                {{ props.sites.length }}
              </template>
              <template v-slot:IP="{ props }">
                {{ props.sites | sumByStat('site.stat.ip') }}
              </template> 
              <template v-slot:PA="{ props }">
                {{ props.sites | sumByStat('site.stat.pa', props.sites.length) }}
              </template>
              <template v-slot:DA="{ props }">
                {{ props.sites | sumByStat('site.stat.da', props.sites.length) }}
              </template>
              <template v-slot:TF="{ props }">
                {{ props.sites | sumByStat('site.stat.tf', props.sites.length) }}
              </template>
              <template v-slot:CF="{ props }">
                {{ props.sites | sumByStat('site.stat.cf', props.sites.length) }}
              </template>
              <template v-slot:Totaal="{ props }">
                <del>{{ $_.sumBy(props.sites, 'price') | currency }}</del>
              </template>
              <template v-slot:Pakketprijs="{ props }">
                {{ props.price | currency }}
              </template>
              <template v-slot:Acties="{ props }">
                <a
                  :href="$route('packages.show', props.id)"
                  class="btn btn-sm btn-success"
                  data-toggle="tooltip"
                  data-placement="top"
                  data-original-title="Pakket bekijken"
                >
                  <i class="fa fa-eye"></i> Bekijken
                </a>
              </template>
            </bs-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['categories'],
  filters: {
    sumByStat: function(array, iteratee, dividing = 1) {
      const total = _.sumBy(array, function(o) {
        return parseFloat(_.get(o, iteratee));
      });

      return (total / dividing).toFixed(0);
    }
  }
};
</script>
